/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
const SettingTab = {
  getTabMenus: roomId => {
    const isEdit = Number.isInteger(Number(roomId))
    return isEdit
      ? [
          { label: '基本情報', url: `/setting/${roomId}/info` }
          // { label: 'タブレット', url: `/setting/${roomId}/tablet` },
          // { label: 'センサー', url: `/setting/${roomId}/sensor` }
        ]
      : [{ label: '基本情報', url: '/setting/info/new' }]
  }
}

export default SettingTab
